<template>
  <div
    :class="[
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: stateStoreInstance.open },
    ]"
    id="sidebar-area"
  >
  <div class="sidebar-menu">
      <div class="logo position-absolute start-0 end-0 top-0 bg-black division-company-name">
          <img :src="getConfigurations.white_label_logo != null ? getConfigurations.white_label_logo : 'https://general-sanvault-bucket.s3.us-east-2.amazonaws.com/logo/1761340970_favicon2.png'" alt="logo-icon" width="30" />
          <span class="company-name fw-bold ms-10">{{ getConfigurations.white_label }}</span>
        <div class="bb-2"></div>
        <button
          class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
          @click="stateStoreInstance.onChange"
        >
          <i class="ph ph-x"></i>
        </button>
      </div>
      <ul
        class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
        id="sidebarNavAccordion"
      >

        <li v-if="getPermissions.includes('access.dashboard')" @click="stateStoreInstance.onChange" class="dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/dashboard" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isDashboardActive }">
              <i class="flaticon-pie-chart-1"></i>
              <span class="title">Dashboard</span>
            </div>
          </router-link>
        </li>

        <li v-if="getPermissions.includes('access.performance')" @click="stateStoreInstance.onChange" class="performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/performance" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isPerformanceActive }">
              <i class="flaticon-bar-chart-1"></i>
              <span class="title">Performance</span>
            </div>
          </router-link>
        </li>

        <li v-if="getPermissions.includes('access.recordings')" @click="stateStoreInstance.onChange" class="gravacoes sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/recordings" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isRecordingsActive }">
              <i class="flaticon-headphones"></i>
              <span class="title">Gravações</span>
            </div>
          </router-link>
        </li>
        
        <li v-if="getPermissions.includes('access.realtime')" @click="stateStoreInstance.onChange" class="realtime sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
            <router-link to="/realtime" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
              <div :class="{ active: isRealtimeActive }">
                <i class="flaticon-track"></i>
                <span class="title">Realtime</span>
              </div>
            </router-link>
        </li>
        
        <li v-if="getPermissions.includes('access.configurations')" @click="stateStoreInstance.onChange" class="configuracoes performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/operations" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isOperationsActive }">
              <i class="flaticon-settings-1"></i>
              <span class="title">Configurações</span>
            </div>
          </router-link>
        </li>

        <li v-if="getPermissions.includes('access.users')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/users" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isUsersActive }">
              <i class="flaticon-user-1"></i>
              <span class="title">Usuários</span>
            </div>
          </router-link>
        </li>
        
        <li v-if="hasWaltRegistrationsPermission" @click="stateStoreInstance.onChange" class="walt-registrations sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/eventos/inscricoes" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isWaltRegistrationsActive }">
              <i class="flaticon-document"></i>
              <span class="title">Eventos</span>
            </div>
          </router-link>
        </li>

        <li v-if="getPermissions.includes('access.payment')" @click="stateStoreInstance.onChange" class="pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/payment" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isPaymentActive }">
              <i class="flaticon-credit-card"></i>
              <span class="title">Pagamentos</span>
            </div>
          </router-link>
        </li>
        
        <li v-if="getPermissions.includes('access.documentation')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/documentation" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isDocumentationActive }">
              <i class="flaticon-document"></i>
              <span class="title">Documentação</span>
            </div>
          </router-link>
        </li>

      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import stateStore from "../../utils/store";
import { useRoute } from "vue-router";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "MainSidebar",
  setup() {
    const stateStoreInstance = stateStore;
    const route = useRoute();    
    
    const isDashboardActive = computed(() => route.path === '/dashboard');
    const isPerformanceActive = computed(() => route.path === '/performance');
    const isRecordingsActive = computed(() => route.path === '/recordings');
    const isRealtimeActive = computed(() => route.path === '/realtime');
    const isOperationsActive = computed(() => route.path === '/operations');
    const isUsersActive = computed(() => route.path === '/users');
    const isWaltRegistrationsActive = computed(() => route.path === '/eventos/inscricoes' || route.path === '/walt-inscricoes');
    const isPaymentActive = computed(() => route.path === '/payment');
    const isDocumentationActive = computed(() => route.path === '/documentation');

    return {
      stateStoreInstance,
      isDashboardActive,
      isPerformanceActive,
      isRecordingsActive,
      isRealtimeActive,
      isOperationsActive,
      isUsersActive,
      isWaltRegistrationsActive,
      isPaymentActive,
      isDocumentationActive
    };
  },
  computed:{
    ...mapGetters([
      'getPermissions',
      'getConfigurations'
    ]),
    hasWaltRegistrationsPermission(): boolean {
      const permissions = (this.getPermissions || []) as string[];

      return permissions.includes('access.event_registrations')
        || permissions.includes('access.walt_registrations')
        || permissions.includes('access.walt-inscricoes')
        || permissions.includes('access.walt_inscricoes');
    }
  },
});
</script>
<style scoped>
.active {
  color: #fff;
}

.company-name{
  font-size: 16pt;
  color: #fff;
}

.division-company-name{
  border-bottom: 1px solid #444 !important;
}
</style>
